import { render, staticRenderFns } from "./MailEnroll.vue?vue&type=template&id=496bbd3e&"
import script from "./MailEnroll.vue?vue&type=script&lang=js&"
export * from "./MailEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports